import { Button } from '@chakra-ui/react'
import { ReactNode } from 'react'
import {
  BUTTON_COLOR_PRIMARY,
  BUTTON_COLOR_PRIMARY_SHADE,
  DOPPEL_BUTTON_GREY,
  DOPPEL_BUTTON_GREY_SHADE,
  DOPPEL_INTERNAL_PURPLE,
  DOPPEL_INTERNAL_PURPLE_SHADE,
  DOPPEL_TEXT_BLACK,
  DOPPEL_TEXT_WHITE,
  FONT_SIZE_MEDIUM,
} from '../../utils/style'
export const getButtonColorScheme = (isInternal: boolean, isPrimaryColor: boolean) => {
  if (isInternal) {
    return {
      bg: DOPPEL_INTERNAL_PURPLE,
      hover: DOPPEL_INTERNAL_PURPLE_SHADE,
      text: DOPPEL_TEXT_WHITE,
    }
  } else if (isPrimaryColor) {
    return {
      bg: BUTTON_COLOR_PRIMARY,
      hover: BUTTON_COLOR_PRIMARY_SHADE,
      text: DOPPEL_TEXT_BLACK,
    }
  } else {
    return {
      bg: DOPPEL_BUTTON_GREY,
      hover: DOPPEL_BUTTON_GREY_SHADE,
      text: DOPPEL_TEXT_WHITE,
    }
  }
}
export type DoppelPrimaryButtonProps = {
  /** The text to display in the button */
  children: ReactNode
  /** Is the button primarily for internal use? */
  isInternal?: boolean
  /** Should the button use the primary color scheme or the alternative */
  isPrimaryColor?: boolean
  /** Is the button disabled? */
  isDisabled?: boolean
  /** Additional button props to customize the button */
  [key: string]: any
}
/**
 * The primary button used throughout the Doppel App
 */
const DoppelPrimaryButton: React.FC<DoppelPrimaryButtonProps> = ({
  children,
  isInternal = false,
  isPrimaryColor = false,
  isDisabled = false,
  ...props
}: DoppelPrimaryButtonProps) => {
  const {
    bg: bgColor,
    hover: hoverColor,
    text: textColor,
  } = getButtonColorScheme(isInternal, isPrimaryColor)

  const buttonProps = {
    ...props,
    isDisabled: isDisabled, // Chakra UI's prop
    disabled: isDisabled, // HTML attribute
    'aria-disabled': isDisabled, // ARIA attribute for accessibility
  }

  return (
    <Button
      _hover={{ background: hoverColor }}
      as={Button}
      bgColor={bgColor}
      fontSize={FONT_SIZE_MEDIUM}
      height={8}
      minWidth="80px"
      textColor={textColor}
      {...buttonProps}
    >
      {children}
    </Button>
  )
}

export default DoppelPrimaryButton
